import { app } from '../../../../app';

app.factory('UsbSamlLoginHandler', UsbSamlLoginHandler);

/** @ngInject */
function UsbSamlLoginHandler($rootScope, $location, $state, SamlService) {
    return {
        login : function(username, authenticationRequests, captchaResponse, errorCallback) {
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
            SamlService.getSPWebSamlDataUsb.get({
                SAMLTracker: $location.search().SAMLTracker,
                appKey : appKey,
                username : username,
                authenticationRequests : authenticationRequests,
                captchaResponse : captchaResponse
            }, function(data) {

                var form = document.createElement("form");
                form.setAttribute('method',"post");

                var i;
                if(null != data.samlResponse) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "SAMLResponse");
                    i.setAttribute('value', data.samlResponse);
                    form.appendChild(i);
                }

                if(null !=data.relayState) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "RelayState");
                    i.setAttribute('value', data.relayState);
                    form.appendChild(i);
                }

                if(null != data.wtrealm){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wresult");
                    i.setAttribute('value',data.wtrealm);
                    form.appendChild(i);
                }

                if(null != data.wctx){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wctx");
                    i.setAttribute('value',data.wctx);
                    form.appendChild(i);
                }

                if(null != data.wa){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wa");
                    i.setAttribute('value',data.wa);
                    form.appendChild(i);
                }

                if(null != data.casLt){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"lt");
                    i.setAttribute('value',data.casLt);
                    form.appendChild(i);
                }

                if (null != data.casExecution) {
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"execution");
                    i.setAttribute('value',data.casExecution);
                    form.appendChild(i);
                }

                if (null != data.casEventId) {
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"_eventId");
                    i.setAttribute('value',data.casEventId);
                    form.appendChild(i);
                }

                form.setAttribute('action', data.redirectionLink);
                document.body.appendChild(form);

                localStorage.setItem('loginAttempts', 0);

                form.submit();
            }, function(error) {
                const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                localStorage.setItem('loginAttempts', loginAttempts + 1);
                errorCallback(error);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/usb-saml-login-handler.service.js